import { render, staticRenderFns } from "./card_best_of_categories.vue?vue&type=template&id=fa5e16a0&scoped=true"
import script from "./card_best_of_categories.vue?vue&type=script&lang=js"
export * from "./card_best_of_categories.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa5e16a0",
  null
  
)

export default component.exports